module.exports = __webpack_public_path__ + "static/media/Dark-Paws.4dd0ecc4.png";